import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, that) {
  return {
    fontWeight:
      that.state.name.indexOf(name.label) === -1
        ? that.props.theme.typography.fontWeightRegular
        : that.props.theme.typography.fontWeightMedium,
  };
}

class MultipleSelect extends React.Component {
  state = {
    name: [],
    isDisplayPlaceholder: true,
  };

  componentWillMount () {
    if(this.props.defaultValue){
      this.setState({ name: this.props.defaultValue }); 
    }   
  }

  handleChange = event => {
    this.props.onChange(this.props.title, event.target.value );
    this.setState({ name: event.target.value });
  };

  handleChangeMultiple = event => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      name: value
    });
  };

  render() {
    const { classes, selectOptions } = this.props;

    return (
      <div className={'multiple-container ' + classes.root}>
        <FormControl className={classes.formControl + ' form-control-style'}>
          <InputLabel htmlFor="select-multiple-chip" className='multiple-input-label'>{this.props.multipleSelectPlaceholder}</InputLabel>
          <Select className='multiple-select-ul'
            multiple
            value={this.state.name}
            onChange={this.handleChange}
            input={<Input name={this.props.multipleSelectPlaceholder} id="select-multiple-chip" />}
            renderValue={selected => (
              <div className={classes.chips}>
                {selected.map(value => (
                  <Chip key={value} label={value} className={classes.chip + ' chip-select-style'} />
                ))}
              </div>
            )}
            MenuProps={MenuProps}
          >
          {selectOptions ? selectOptions.map(name => (
              <MenuItem key={name.value} value={name.value} className='menu-item-li' style={getStyles(name, this)}>
                {name.label}
              </MenuItem>
            ))
          : null } 
          </Select>
        </FormControl>
      </div>
    );
  }
}

MultipleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MultipleSelect);